import './Loader.css'
export const Loader = () => {
    return (
        <div className="custom-loader-overlay">
            <div className="spinner"></div>
        </div>
    );
};
